import React from 'react';
import cx from 'classnames';
import { ReactComponent as Facebook } from '../assets/facebook.svg';
import { ReactComponent as Instagram } from '../assets/instagram.svg';
import { ReactComponent as Twitter } from '../assets/twitter.svg';
import { ReactComponent as Blog } from '../assets/blog.svg';
import { ReactComponent as TikTok } from '../assets/tiktok.svg';

const components = {
  facebook: {
    component: Facebook,
    styles: {
      width: '20px',
      height: '20px',
    },
  },
  instagram: {
    component: Instagram,
    styles: {
      width: '20px',
      height: '20px',
    },
  },
  twitter: {
    component: Twitter,
    styles: {
      width: '20px',
      height: '20px',
    },
  },
  blog: {
    component: Blog,
    styles: {
      width: '20px',
      height: '20px',
    },
  },
  tiktok: {
    component: TikTok,
    styles: {
      width: '20px',
      height: '20px',
    },
  },
};

export function SocialMedia({
  links,
  color = 'text-primary',
  hover = 'text-primary-dark',
  ...props
}) {
  return (
    <>
      {links.map((link, key) => {
        const Icon = components[link.site]['component'];

        return (
          <a
            href={link.url}
            key={key}
            className="inline-block mx-2"
            style={components[link.site]['styles']}
            {...props}
            target="_blank"
          >
            <Icon
              className={cx(
                `transition duration-500 fill-current w-full h-full`,
                color,
                hover
              )}
            />
          </a>
        );
      })}
    </>
  );
}
